import { render, staticRenderFns } from "./ValidationForm.vue?vue&type=template&id=f9691118&"
import script from "./ValidationForm.vue?vue&type=script&lang=js&"
export * from "./ValidationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports